import { createContext, useContext, useEffect, useState } from 'react';
import { fetchStaffReferences, fetchCarModelReferences, fetchCarSpotReferences } from '@/services/api/user-references';
import { StaffReference, CarModelReference, CarSpotReference } from '@/types';

interface MasterReferencesContextValue {
  staffRefs: StaffReference[];
  carModelRefs: CarModelReference[];
  carSpotRefs: CarSpotReference[];
  refresh: () => void;
}

const MasterReferencesContext = createContext<MasterReferencesContextValue | null>(null);

export const useMasterReferences = () => {
  const ctx = useContext(MasterReferencesContext);
  if (!ctx) throw new Error('useMasterReferences must be used within MasterReferencesProvider');
  return ctx;
};

export const MasterReferencesProvider = ({ children }: { children: React.ReactNode }) => {
  const [staffRefs, setStaffRefs] = useState<StaffReference[]>([]);
  const [carModelRefs, setCarModelRefs] = useState<CarModelReference[]>([]);
  const [carSpotRefs, setCarSpotRefs] = useState<CarSpotReference[]>([]);

  const load = () => {
    fetchStaffReferences('shared').then(setStaffRefs).catch(() => setStaffRefs([]));
    fetchCarModelReferences('shared').then(setCarModelRefs).catch(() => setCarModelRefs([]));
    fetchCarSpotReferences('shared').then(setCarSpotRefs).catch(() => setCarSpotRefs([]));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <MasterReferencesContext.Provider value={{ staffRefs, carModelRefs, carSpotRefs, refresh: load }}>
      {children}
    </MasterReferencesContext.Provider>
  );
};
